import React, { useState } from 'react';
import { Form, Spinner, } from 'react-bootstrap';
import STLViewer from './STLViewer';
import { Button, Card, CardBody, CardHeader, Col, Container, FormGroup, Input, Label, Row } from 'reactstrap';

function SearchPage() {
  const [partType, setPartType] = useState("roundtable");
  const [diameter, setDiameter] = useState(2000);
  const [legHeight, setLegHeight] = useState(800);
  const [length, setLength] = useState(2000);
  const [width, setWidth] = useState(1000);
  const [height, setHeight] = useState(500);

  const [stlUrl, setStlUrl] = useState("");
  const [stepUrl, setStepUrl] = useState("");
  const [pdfUrl, setPdfUrl] = useState("");
  const [loading, setLoading] = useState(false);

    const openLink = (url) => window.open(url, "_blank", "noopener,noreferrer");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const dimensions = partType === "roundtable"
      ? { diameter, legHeight }
      : partType === "rectangletable"
      ? { length, width, legHeight }
      : { length, width, height };
//https://040ce36b0421.ngrok-free.app/
//https://aa95ca05afd8.ngrok-free.app/
//http://localhost:5001/generate-part
    try {
      const res = await fetch("https://ab5f3d60280d.ngrok-free.app/generate-part", {
         method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ partType, dimensions }),
});

      const files = await res.json();
      setStlUrl(files.STLUrl);
      setStepUrl(files.STEPUrl);
      setPdfUrl(files.PDFUrl);
    } catch (err) {
      console.error(err);
      alert("Error generating part");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container fluid className="mt-4">
      <h5>SolidWorks Product Configure</h5>
      <Row>
        {/* Sidebar for inputs */}
        <Col md={3}>
          <Card>
            <CardHeader>Part Parameters</CardHeader>
            <CardBody>
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label>Part Type</Form.Label>
                  <Form.Select value={partType} onChange={(e) => setPartType(e.target.value)}>
                    <option value="roundtable">Round Table</option>
                    <option value="rectangletable">Rectangle Table</option>
                    <option value="box">Box</option>
                  </Form.Select>
                </Form.Group>

                {partType === "roundtable" && (
                  <>
                    <FormGroup className="mb-3">
                      <Label>Diameter (mm)</Label>
                      <Input type="number" value={diameter} onChange={(e) => setDiameter(Number(e.target.value))} />
                    </FormGroup>
                    <FormGroup className="mb-3">
                      <Label>Leg Height (mm)</Label>
                      <Input type="number" value={legHeight} onChange={(e) => setLegHeight(Number(e.target.value))} />
                    </FormGroup>
                  </>
                )}

                {partType === "rectangletable" && (
                  <>
                    <FormGroup className="mb-3">
                      <Form.Label>Length (mm)</Form.Label>
                      <Form.Control type="number" value={length} onChange={(e) => setLength(Number(e.target.value))} />
                    </FormGroup>
                    <FormGroup className="mb-3">
                      <Label>Width (mm)</Label>
                      <Input type="number" value={width} onChange={(e) => setWidth(Number(e.target.value))} />
                    </FormGroup>
                    <FormGroup className="mb-3">
                      <Label>Leg Height (mm)</Label>
                      <Input type="number" value={legHeight} onChange={(e) => setLegHeight(Number(e.target.value))} />
                    </FormGroup>
                  </>
                )}

                {partType === "box" && (
                  <>
                    <FormGroup className="mb-3">
                      <Label>Length (mm)</Label>
                      <Input type="number" value={length} onChange={(e) => setLength(Number(e.target.value))} />
                    </FormGroup>
                    <FormGroup className="mb-3">
                      <Label>Width (mm)</Label>
                      <Input type="number" value={width} onChange={(e) => setWidth(Number(e.target.value))} />
                    </FormGroup>
                    <FormGroup className="mb-3">
                      <Label>Height (mm)</Label>
                      <Input type="number" value={height} onChange={(e) => setHeight(Number(e.target.value))} />
                    </FormGroup>
                  </>
                )}

                <Button type="submit" disabled={loading} className="w-100">
                  {loading ? (
                    <>
                      <Spinner animation="border" size="sm" /> Generating...
                    </>
                  ) : "Generate Part"}
                </Button>
              </Form>

               {stepUrl && !loading && (
           <Card className="p-3 shadow-sm rounded mt-3">
      <CardBody className="d-flex flex-column gap-2 ">
        <Button
          color="primary"
          outline
          block
          className="d-flex align-items-center justify-content-center gap-2"
          onClick={() => openLink(stlUrl)}
        >
       Download STL
        </Button>

        <Button
          color="success"
          outline
          block
          className="d-flex align-items-center justify-content-center gap-2"
          onClick={() => openLink(stepUrl)}
        >
       Download STEP
        </Button>

        <Button
          color="danger"
          outline
          block
          className="d-flex align-items-center justify-content-center gap-2"
          onClick={() => openLink(pdfUrl)}
        >
           Download PDF
        </Button>
      </CardBody>
    </Card>
          )}
            </CardBody>
          </Card>
        </Col>

        {/* Main panel for preview & downloads */}
        <Col md={8}>
          {loading && (
            <Card className="mb-3">
              <CardBody className="d-flex justify-content-center align-items-center" style={{ height: '400px' }}>
                <Spinner animation="border" /> Generating STL Preview...
              </CardBody>
            </Card>
          )}

          {stlUrl && !loading && (
            <Card className="mb-3">
              <CardHeader>3D Preview</CardHeader>
              <CardBody style={{ height: '700px' }}>
                <STLViewer url={stlUrl} width="100%" height="100%" />
              </CardBody>
            </Card>
          )}

         
        </Col>
      </Row>
    </Container>
  );
}

export default SearchPage;
